import React from "react"
import AppLayoutTop from "@modules/framework/AppLayoutTop"
import lazyloadHelper from "@ng-mw/shared-react-components/lazyloadHelper"

const { WithSuspense: CouponsPage, preload: preloadCouponsPage } = lazyloadHelper(
    () => import(/* webpackChunkName: "savings" */ "@modules/loyalty-club/pages/CouponsPage"),
    <AppLayoutTop />,
)
const { WithSuspense: CouponsPageStandalone, preload: preloadCouponsPageStandalone } =
    lazyloadHelper(
        () =>
            import(
                /* webpackChunkName: "savings" */ "@modules/loyalty-club/pages/CouponsPageStandalone"
            ),
        <AppLayoutTop />,
    )
const { WithSuspense: CampaignPage, preload: preloadCampaignPage } = lazyloadHelper(
    () => import(/* webpackChunkName: "savings" */ "@modules/savings/pages/CampaignPage"),
    <AppLayoutTop />,
)
const { WithSuspense: SavingsPage, preload: preloadSavingsPage } = lazyloadHelper(
    () => import(/* webpackChunkName: "savings" */ "@modules/orders/pages/SavingsPage"),
    <AppLayoutTop />,
)
const { WithSuspense: BestBuyPage, preload: preloadBestBuyPage } = lazyloadHelper(
    () => import(/* webpackChunkName: "savings" */ "@modules/savings/pages/BestBuyPage"),
    <AppLayoutTop />,
)

const { WithSuspense: CartPage, preload: preloadCartPage } = lazyloadHelper(
    () => import(/* webpackChunkName: "cartpage" */ "@modules/cart/pages/CartPage"),
    <AppLayoutTop />,
)
const { WithSuspense: CheckoutPage, preload: preloadCheckoutPage } = lazyloadHelper(
    () => import(/* webpackChunkName: "checkoutpage" */ "@modules/checkout/pages/CheckoutPage"),
    <AppLayoutTop />,
)
const { WithSuspense: ShoppingListsHomePage, preload: preloadShoppingListsHomePage } =
    lazyloadHelper(
        () =>
            import(
                /* webpackChunkName: "handlelister" */ "@modules/shopping-lists/pages/ShoppingListsHomePage"
            ),
        <AppLayoutTop />,
    )
const { WithSuspense: ShoppingListPage, preload: preloadShoppingListPage } = lazyloadHelper(
    () =>
        import(
            /* webpackChunkName: "handlelister" */ "@modules/shopping-lists/pages/ShoppingListItemPage"
        ),
    <AppLayoutTop />,
)
const { WithSuspense: SearchPage, preload: preloadSearchPage } = lazyloadHelper(
    () => import(/* webpackChunkName: "Search" */ "@modules/products/pages/SearchPage"),
    <AppLayoutTop />,
)
const { WithSuspense: CategoryPage, preload: preloadCategoryPage } = lazyloadHelper(
    () => import(/* webpackChunkName: "Search" */ "@modules/products/pages/CategoryPage"),
    <AppLayoutTop />,
)
const { WithSuspense: ContactDetailsPage, preload: preloadContactDetailsPage } = lazyloadHelper(
    () => import(/* webpackChunkName: "users" */ "@modules/user/pages/ContactDetailsPage"),
    <AppLayoutTop />,
)
const { WithSuspense: TrumfProfilePage, preload: preloadTrumfProfilePage } = lazyloadHelper(
    () => import(/* webpackChunkName: "users" */ "@modules/user/pages/TrumfProfilePage"),
    <AppLayoutTop />,
)
const { WithSuspense: TrumfMemberPage, preload: preloadTrumfMemberPage } = lazyloadHelper(
    () => import(/* webpackChunkName: "users" */ "@modules/user/pages/TrumfMemberPage"),
    <AppLayoutTop />,
)
const { WithSuspense: TrumfBankCardsPage, preload: preloadTrumfBankCardsPage } = lazyloadHelper(
    () => import(/* webpackChunkName: "users" */ "@modules/user/pages/TrumfBankCardsPage"),
    <AppLayoutTop />,
)
const { WithSuspense: TrumfCardsPage, preload: preloadTrumfCardsPage } = lazyloadHelper(
    () => import(/* webpackChunkName: "users" */ "@modules/user/pages/TrumfCardsPage"),
    <AppLayoutTop />,
)
const { WithSuspense: TrumfChainConsentsPage, preload: preloadTrumfChainConsentsPage } =
    lazyloadHelper(
        () => import(/* webpackChunkName: "users" */ "@modules/user/pages/TrumfChainConsentsPage"),
        <AppLayoutTop />,
    )
const { WithSuspense: TrumfAnalyticalConsentPage, preload: preloadTrumfAnalyticalConsentPage } =
    lazyloadHelper(
        () => import(/* webpackChunkName: "users" */ "@modules/user/pages/TrumfAnalyticalConsentPage"),
        <AppLayoutTop />,
    )
const { WithSuspense: TrumfAssociatesPage, preload: preloadTrumfAssociatesPage } = lazyloadHelper(
    () => import(/* webpackChunkName: "users" */ "@modules/user/pages/TrumfAssociatesPage"),
    <AppLayoutTop />,
)
const { WithSuspense: UserManageBiometricsPage, preload: preloadUserManageBiometricsPage } =
    lazyloadHelper(
        () =>
            import(/* webpackChunkName: "users" */ "@modules/user/pages/UserManageBiometricsPage"),
        <AppLayoutTop />,
    )
const { WithSuspense: NotificationSettingsPage, preload: preloadNotificationSettingsPage } =
    lazyloadHelper(
        () =>
            import(/* webpackChunkName: "users" */ "@modules/user/pages/NotificationSettingsPage"),
        <AppLayoutTop />,
    )
const {
    WithSuspense: DinnerSuggestionsPreferencesPage,
    preload: preloadDinnerSuggestionsPreferencesPage,
} = lazyloadHelper(
    () =>
        import(
            /* webpackChunkName: "users" */ "@modules/user/pages/DinnerSuggestionsPreferencesPage"
        ),
    <AppLayoutTop />,
)
const { WithSuspense: UseBonusPage, preload: preloadUseBonusPage } = lazyloadHelper(
    () => import(/* webpackChunkName: "users" */ "@modules/user/pages/UseBonusPage"),
    <AppLayoutTop />,
)
const { WithSuspense: UseBonusToBankPage, preload: preloadUseBonusToBankPage } = lazyloadHelper(
    () => import(/* webpackChunkName: "users" */ "@modules/user/pages/UseBonusToBankPage"),
    <AppLayoutTop />,
)
const { WithSuspense: UseBonusToCharityPage, preload: preloadUseBonusToCharityPage } =
    lazyloadHelper(
        () => import(/* webpackChunkName: "users" */ "@modules/user/pages/UseBonusToCharityPage"),
        <AppLayoutTop />,
    )
const { WithSuspense: UserProfilePage, preload: preloadUserProfilePage } = lazyloadHelper(
    () => import(/* webpackChunkName: "users" */ "@modules/user/pages/UserProfilePage"),
    <AppLayoutTop />,
)
const { WithSuspense: BusinessInformationPage, preload: preloadBusinessInformationPage } =
    lazyloadHelper(
        () => import(/* webpackChunkName: "users" */ "@modules/user/pages/BusinessInformationPage"),
        <AppLayoutTop />,
    )
const { WithSuspense: BusinessOrdersPage, preload: preloadBusinessOrdersPage } = lazyloadHelper(
    () => import(/* webpackChunkName: "users" */ "@modules/user/pages/BusinessOrdersPage"),
    <AppLayoutTop />,
)
const { WithSuspense: BusinessUsersPage, preload: preloadBusinessUsersPage } = lazyloadHelper(
    () => import(/* webpackChunkName: "users" */ "@modules/user/pages/BusinessUsersPage"),
    <AppLayoutTop />,
)
const { WithSuspense: BusinessRegistrationPage, preload: preloadBusinessRegistrationPage } =
    lazyloadHelper(
        () =>
            import(/* webpackChunkName: "users" */ "@modules/user/pages/BusinessRegistrationPage"),
        <AppLayoutTop />,
    )
const { WithSuspense: DebugPage, preload: preloadDebugPage } = lazyloadHelper(
    () => import(/* webpackChunkName: "debug" */ "@modules/debug/pages/DebugPage"),
    <AppLayoutTop />,
)
const { WithSuspense: AccessibilityPlaygroundPage, preload: preloadAccessibilityPlaygroundPage } =
    lazyloadHelper(
        () =>
            import(
                /* webpackChunkName: "debug" */ "@modules/debug/pages/AccessibilityPlaygroundPage"
            ),
        <AppLayoutTop />,
    )
const { WithSuspense: ComponentPlaygroundPage, preload: preloadComponentPlaygroundPage } =
    lazyloadHelper(
        () =>
            import(/* webpackChunkName: "debug" */ "@modules/debug/pages/ComponentPlaygroundPage"),
        <AppLayoutTop />,
    )
const { WithSuspense: LoggerPlaygroundPage, preload: preloadLoggerPlaygroundPage } = lazyloadHelper(
    () => import(/* webpackChunkName: "debug" */ "@modules/debug/pages/LoggerPlaygroundPage"),
    <AppLayoutTop />,
)
const { WithSuspense: OrderItemPage, preload: preloadOrderItemPage } = lazyloadHelper(
    () => import(/* webpackChunkName: "purchases" */ "@modules/orders/pages/OrderItemPage"),
    <AppLayoutTop />,
)
const { WithSuspense: OrderHistoryPage, preload: preloadOrderHistoryPage } = lazyloadHelper(
    () => import(/* webpackChunkName: "purchases" */ "@modules/orders/pages/OrderHistoryPage"),
    <AppLayoutTop />,
)
const { WithSuspense: PurchaseHistoryPage, preload: preloadPurchaseHistoryPage } = lazyloadHelper(
    () => import(/* webpackChunkName: "purchases" */ "@modules/orders/pages/PurchaseHistoryPage"),
    <AppLayoutTop />,
)
const { WithSuspense: PurchaseComplaintPage, preload: preloadPurchaseComplaintPage } =
    lazyloadHelper(
        () =>
            import(
                /* webpackChunkName: "purchases" */ "@modules/orders/pages/PurchaseComplaintPage"
            ),
        <AppLayoutTop />,
    )
const { WithSuspense: RecipesHomePage, preload: preloadRecipesHomePage } = lazyloadHelper(
    () => import(/* webpackChunkName: "recipes" */ "@modules/recipes/pages/RecipesHomePage"),
    <AppLayoutTop />,
)
const { WithSuspense: MyRecipesPage, preload: preloadMyRecipesPage } = lazyloadHelper(
    () => import(/* webpackChunkName: "recipes" */ "@modules/recipes/pages/MyRecipesPage"),
    <AppLayoutTop />,
)

const { WithSuspense: ChatPage, preload: preloadChatPage } = lazyloadHelper(
    () => import(/* webpackChunkName: "chatpage" */ "@modules/debug/pages/ChatPage"),
    <AppLayoutTop />,
)
const { WithSuspense: CustomerServicePage, preload: preloadCustomerServicePage } = lazyloadHelper(
    () =>
        import(/* webpackChunkName: "customerservice" */ "@modules/user/pages/CustomerServicePage"),
    <AppLayoutTop />,
)
const { WithSuspense: DietHomePage, preload: preloadDietHomePage } = lazyloadHelper(
    () => import(/* webpackChunkName: "dietinsight" */ "@modules/insight/diet/pages/DietHomePage"),
    <AppLayoutTop />,
)
const { WithSuspense: DietOverviewPage, preload: preloadDietOverviewPage } = lazyloadHelper(
    () =>
        import(
            /* webpackChunkName: "dietinsight" */ "@modules/insight/diet/pages/DietOverviewPage"
        ),
    <AppLayoutTop />,
)
const { WithSuspense: DietMacroNutrientsPage, preload: preloadDietMacroNutrientsPage } =
    lazyloadHelper(
        () =>
            import(
                /* webpackChunkName: "dietinsight" */ "@modules/insight/diet/pages/DietMacroNutrientsPage"
            ),
        <AppLayoutTop />,
    )
const { WithSuspense: DietLevelOnePage, preload: preloadDietLevelOnePage } = lazyloadHelper(
    () =>
        import(
            /* webpackChunkName: "dietinsight" */ "@modules/insight/diet/pages/DietLevelOnePage"
        ),
    <AppLayoutTop />,
)
const { WithSuspense: DietLevelTwoPage, preload: preloadDietLevelTwoPage } = lazyloadHelper(
    () =>
        import(
            /* webpackChunkName: "dietinsight" */ "@modules/insight/diet/pages/DietLevelTwoPage"
        ),
    <AppLayoutTop />,
)
const { WithSuspense: DietLevelThreePage, preload: preloadDietLevelThreePage } = lazyloadHelper(
    () =>
        import(
            /* webpackChunkName: "dietinsight" */ "@modules/insight/diet/pages/DietLevelThreePage"
        ),
    <AppLayoutTop />,
)
const { WithSuspense: DietLevelFourPage, preload: preloadDietLevelFourPage } = lazyloadHelper(
    () =>
        import(
            /* webpackChunkName: "dietinsight" */ "@modules/insight/diet/pages/DietLevelFourPage"
        ),
    <AppLayoutTop />,
)
const { WithSuspense: ClimateHomePage, preload: preloadClimateHomePage } = lazyloadHelper(
    () =>
        import(
            /* webpackChunkName: "climateinsight" */ "@modules/insight/climate/pages/ClimateHomePage"
        ),
    <AppLayoutTop />,
)
const { WithSuspense: ClimateProductGroupsPage, preload: preloadClimateProductGroupsPage } =
    lazyloadHelper(
        () =>
            import(
                /* webpackChunkName: "climateinsight" */ "@modules/insight/climate/pages/ClimateProductGroupsPage"
            ),
        <AppLayoutTop />,
    )
const { WithSuspense: ClimateLevelTwoPage, preload: preloadClimateLevelTwoPage } = lazyloadHelper(
    () =>
        import(
            /* webpackChunkName: "climateinsight" */ "@modules/insight/climate/pages/ClimateLevelTwoPage"
        ),
    <AppLayoutTop />,
)
const { WithSuspense: ClimateLevelThreePage, preload: preloadClimateLevelThreePage } =
    lazyloadHelper(
        () =>
            import(
                /* webpackChunkName: "climateinsight" */ "@modules/insight/climate/pages/ClimateLevelThreePage"
            ),
        <AppLayoutTop />,
    )

const allPreloaders = [
    preloadAccessibilityPlaygroundPage,
    preloadBestBuyPage,
    preloadBusinessInformationPage,
    preloadBusinessOrdersPage,
    preloadBusinessUsersPage,
    preloadBusinessRegistrationPage,
    preloadCampaignPage,
    preloadCartPage,
    preloadCategoryPage,
    preloadChatPage,
    preloadCheckoutPage,
    preloadClimateHomePage,
    preloadClimateLevelThreePage,
    preloadClimateLevelTwoPage,
    preloadClimateProductGroupsPage,
    preloadComponentPlaygroundPage,
    preloadContactDetailsPage,
    preloadCouponsPage,
    preloadCouponsPageStandalone,
    preloadCustomerServicePage,
    preloadDebugPage,
    preloadDietHomePage,
    preloadDietLevelFourPage,
    preloadDietLevelOnePage,
    preloadDietLevelThreePage,
    preloadDietLevelTwoPage,
    preloadDietMacroNutrientsPage,
    preloadDietOverviewPage,
    preloadDinnerSuggestionsPreferencesPage,
    preloadLoggerPlaygroundPage,
    preloadMyRecipesPage,
    preloadNotificationSettingsPage,
    preloadOrderHistoryPage,
    preloadOrderItemPage,
    preloadPurchaseComplaintPage,
    preloadPurchaseHistoryPage,
    preloadRecipesHomePage,
    preloadSavingsPage,
    preloadSearchPage,
    preloadShoppingListPage,
    preloadShoppingListsHomePage,
    preloadTrumfAssociatesPage,
    preloadTrumfBankCardsPage,
    preloadTrumfCardsPage,
    preloadTrumfChainConsentsPage,
    preloadTrumfAnalyticalConsentPage,
    preloadTrumfMemberPage,
    preloadTrumfProfilePage,
    preloadUseBonusPage,
    preloadUseBonusToBankPage,
    preloadUseBonusToCharityPage,
    preloadUserManageBiometricsPage,
    preloadUserProfilePage,
]

export function doPreload() {
    // DebugLogger.log("Load-order-debug: preloading components's now!")
    // Make sure all routes preload and are ready from the get go.
    // Also fixes transition-animation bug for first render.
    for (const preload of allPreloaders) {
        preload()
    }
}

export {
    AccessibilityPlaygroundPage,
    BestBuyPage,
    BusinessInformationPage,
    BusinessOrdersPage,
    BusinessUsersPage,
    BusinessRegistrationPage,
    CampaignPage,
    CartPage,
    CategoryPage,
    ChatPage,
    CheckoutPage,
    ClimateHomePage,
    ClimateLevelThreePage,
    ClimateLevelTwoPage,
    ClimateProductGroupsPage,
    ComponentPlaygroundPage,
    ContactDetailsPage,
    CouponsPage,
    CouponsPageStandalone,
    CustomerServicePage,
    DebugPage,
    DietHomePage,
    DietLevelFourPage,
    DietLevelOnePage,
    DietLevelThreePage,
    DietLevelTwoPage,
    DietMacroNutrientsPage,
    DietOverviewPage,
    DinnerSuggestionsPreferencesPage,
    LoggerPlaygroundPage,
    MyRecipesPage,
    NotificationSettingsPage,
    OrderHistoryPage,
    OrderItemPage,
    PurchaseComplaintPage,
    PurchaseHistoryPage,
    RecipesHomePage,
    SavingsPage,
    SearchPage,
    ShoppingListPage,
    ShoppingListsHomePage,
    TrumfAssociatesPage,
    TrumfBankCardsPage,
    TrumfCardsPage,
    TrumfChainConsentsPage,
    TrumfAnalyticalConsentPage,
    TrumfMemberPage,
    TrumfProfilePage,
    UseBonusPage,
    UseBonusToBankPage,
    UseBonusToCharityPage,
    UserManageBiometricsPage,
    UserProfilePage,
}
